<template>
  <div class="col-xl-12">
    <div class="appointment">
      <div class="card">
        <div class="card-header card-no-border">
          <div class="header-top">
            <h5 class="m-0">DSR wise Sale</h5>
          </div>
        </div>
        <div class="card-body" :class="loading ? 'loading-center' : 'pt-0'">
          <div class="appointment-table table-responsive">
            <!-- Loading spinner -->
            <div v-if="loading" class="spinner-container">
              <div class="spinner"></div> <!-- Circular Spinner -->
            </div>

            <!-- Error Message -->
            <div v-if="error" class="text-center error-message">
              <img src="../../../../assets/vectors/no_sales.png" alt="Error" class="error-image" />
              <p>{{ error }}</p>
            </div>

            <!-- Table Data -->
            <table v-if="!loading && !error" class="table table-bordernone">
              <tbody>
              <tr v-for="(item, index) in resentSales" :key="item.name">
                <td>
                  <!-- Avatar with fixed background and text color -->
                  <div
                      class="avatar rounded-circle me-2"
                      :style="{ backgroundColor: '#F4B400', color: '#000' }"
                  >
                    <span>{{ getInitials(item.name) }}</span>
                  </div>
                </td>
                <td class="img-content-box">
                  <h6 class="f-14 mb-0">{{ item.name }}</h6>
                </td>
                <td class="text-end">
                  <p class="m-0 text-black">{{ item.amount }}</p>
                </td>
              </tr>
              </tbody>
            </table>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { dsrWiseSalesData } from '@/services/dataService';  // Import the DSR wise sales data service

export default {
  data() {
    return {
      resentSales: [],  // To hold the fetched sales data
      token: localStorage.getItem('token_set'), // Get token from localStorage
      loading: false,   // Loading state
      error: null,      // Error state
    };
  },
  created() {
    this.fetchDSRWiseSales();  // Fetch the data when the component is created
  },
  methods: {
    async fetchDSRWiseSales() {
      const profileId = localStorage.getItem('profile_id');  // Retrieve profile ID from localStorage

      if (!profileId) {
        console.error('Profile ID not found in localStorage');
        this.error = 'Profile ID not found';
        return;
      }

      try {
        this.loading = true; // Set loading to true while fetching the data
        const response = await dsrWiseSalesData(profileId, this.token);  // Fetch DSR wise sales data

        if (response.data && response.data.resentSales) {
          this.resentSales = response.data.resentSales;  // Map the API response to the resentSales array
        } else {
          this.error = response.data.message || 'Failed to fetch data.';
        }
      } catch (error) {
        this.error = 'An error occurred while fetching sales data.';
        console.error('Error fetching DSR wise sales data:', error);
      } finally {
        this.loading = false; // Reset loading state when done
      }
    },
    // Method to get the initials from the name
    getInitials(name) {
      const names = name.split(" ");
      const firstInitial = names[0] ? names[0][0].toUpperCase() : "";
      const lastInitial = names[1] ? names[1][0].toUpperCase() : "";
      return `${firstInitial}${lastInitial}`;
    },
  },
};
</script>

<style scoped>
/* Spinner container styling */
.spinner-container {
  display: flex;
  justify-content: center;
  align-items: center;
  height: 150px; /* Set a height to vertically center the spinner */
}

/* Spinner styling */
.spinner {
  border: 4px solid rgba(0, 0, 0, 0.1); /* Light border */
  border-top: 4px solid #F4B400; /* Spinner color (green theme) */
  border-radius: 50%;
  width: 36px;
  height: 36px;
  animation: spin 1s linear infinite;
}

/* Animation for the spinner */
@keyframes spin {
  0% { transform: rotate(0deg); }
  100% { transform: rotate(360deg); }
}

/* Centering the spinner when loading */
.loading-center {
  display: flex;
  justify-content: center;
  align-items: center;
  height: 300px; /* Optional fixed height */
}

/* Avatar styling */
.avatar {
  width: 40px; /* Set width of avatar */
  height: 40px; /* Set height of avatar */
  display: flex; /* Enable flexbox for centering */
  align-items: center; /* Center vertically */
  justify-content: center; /* Center horizontally */
  font-size: 18px; /* Font size for initials */
  font-weight: lighter; /* Light font weight */
  border-radius: 50%; /* Makes the avatar circular */
  text-transform: uppercase; /* Uppercase for initials */
}

/* Results not found image */
.error-image {
  max-width: 180px;
}

/* Results not found message */
.error-message {
  font-size: 25px;
  font-weight: bold;
  color: #ff735e;
  margin-top: -25px;
}
</style>
